import { Directive } from '@angular/core';
import {CdkPortal} from '@angular/cdk/portal';

@Directive({
  selector: '[appTabLabel]'
})
export class TabLabelDirective extends CdkPortal { }
